export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtSNNDNahrada';
export const NAME = 'VolitelnyMaterialSp';
